export default "__VITE_ASSET__469c397c__"